module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: _vm.classes,
    style: (_vm.outerStyles)
  }, [_c('div', {
    class: _vm.innerClasses,
    style: (_vm.styles)
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9616b8b0!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/loading-bar/loading-bar.vue
// module id = 1791
// module chunks = 115